$(document).ready(function () {
  let p = $("body").attr("p");

  if (p == "order_confirmation" || p == "organizer_event_customers") {
    $(document).on("click", ".return-order-confirm-btn", function (e) {
      e.preventDefault();
      const orderId = $(this).attr("data-order-id");
      const button = $(this);
      const btnWidth = button.outerWidth();
      button.css("width", btnWidth + "px");
      button.prop("disabled", true);
      button.html('<i class="spinner-border spinner-border-sm"></i>');
      $.ajax({
        type: "POST",
        url: "/api/v1/private/order/return-order",
        data: { orderId },
      })
        .done(function (data) {
          if (data && data.success && data.redirect_url) {
            popupAlert();
            button.prop("disabled", false);
            button.html("Bekreft");
            $("#return-order-model").modal("hide");
            setTimeout(() => {
              $("#return-order-model").remove();
              document.location.href = data.redirect_url;
            }, 1000);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html("Bekreft");
          }
        })
        .always(function () {
          button.prop("disabled", false);
          button.html("Bekreft");
          $("#return-order-model").modal("hide");
          setTimeout(() => {
            $("#return-order-model").remove();
          }, 300);
        });
    });
  }
});
